<script>
export default {
    name: 'MovedNotice',
    props: {
        title: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
    },
}
</script>

<template>
    <div class="moved">
        <div class="sa-card moved__cell">
            <h1>{{ title }} se ha trasladado</h1>
            <p class="text-muted">Esta pantalla ya no se mantiene. Abre {{ title }} en el panel de ShiftOS.</p>
            <b-button :href="url" target="_blank" variant="primary">Abrir {{ title }}</b-button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.moved {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 70vh;
    padding: 24px var(--page-x);
}
.moved__cell {
    width: 100%;
    max-width: 420px;
    text-align: center;
}
.moved__cell h1 {
    margin-bottom: 12px;
}
.moved__cell p {
    margin-bottom: 20px;
}
</style>
